<nz-modal [nzVisible]="visible" nzTitle="More Date Picker" [nzOkDisabled]="disabled" (nzOnCancel)="visible = false" (nzOnOk)="onOk()"
    [nzWidth]="'500px'">
    <ng-container *nzModalContent>
        <div *ngIf="postDatePicker">
            <nz-form-item>
                <nz-form-label nzFor="postDate" nzRequired [nzSpan]="6">Post Date</nz-form-label>
                <nz-form-control nzErrorTip="Posting Date is required">
                    <nz-date-picker name="postDate" 
                        [(ngModel)]="postDate"
                        [nzFormat]="dateFormatService.currentDateFormatValue" 
                        [nzAllowClear]="false"
                        [nzDisabledDate]="disabledDate" 
                        [nzDisabled]="disabled"
                        required>
                    </nz-date-picker>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div *ngIf="taxDatePicker">
            <nz-form-item>
                <nz-form-label nzFor="taxDate" nzRequired [nzSpan]="6">Tax Date</nz-form-label>
                <nz-form-control nzErrorTip="Tax Date is required">
                    <nz-date-picker name="taxDate" 
                        [(ngModel)]="taxDate"
                        [nzFormat]="dateFormatService.currentDateFormatValue"
                        [nzAllowClear]="false"
                        [nzDisabledDate]="disabledDate" 
                        [nzDisabled]="disabled"
                        required>
                    </nz-date-picker>
                </nz-form-control>
            </nz-form-item>
        </div>
    </ng-container>
</nz-modal>